import { render, staticRenderFns } from "./DragVerticalIcon.vue?vue&type=template&id=2dc04bd2&"
import script from "./DragVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./DragVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports